import { IDeltaHedgeExeDetailedStateTradeTableSearchParam } from "../../../../Interfaces/deltaHedgeExe";
import { ITableReport } from "../../../../Interfaces/TableInterfaces";
import { getDeltaHedgeExeDetailedStateTradeTable } from "../../../../Requests/adjustment";
import { CommonTableUI } from "../../../TableTemplate/common";
import TableTemplate from "../../../TableTemplate/tableTemplate";
import { Additional } from "./Additional";

interface IProps {
  id: number;
}

const TradeTable = ({ id }: IProps) => {
  return (
    <TableTemplate<
      IDeltaHedgeExeDetailedStateTradeTableSearchParam,
      ITableReport
    >
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getDeltaHedgeExeDetailedStateTradeTable}
      initialSearchParameters={{ taskId:id ,id }}
    />
  );
};

export default TradeTable;
